export default "__VITE_ASSET__DXuVg34m__"